import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable video card.
 */
const VideoCard = ({ title, duration, category, date, image, link = '#', variant = 'standard' }) => {
  const isUrl = image && (image.startsWith('http') || image.startsWith('/'));

  if (variant === 'hero') {
    return (
      <div className="card news-card news-card--hero">
        <div className="card__image" style={{ aspectRatio: '16/9', minHeight: 300, background: 'var(--color-surface-subtle)', position: 'relative', overflow: 'hidden' }}>
          {isUrl ? (
            <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#1f1a17,#57110f)' }} />
          )}
          <div className="video-card__play" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 80, height: 80, fontSize: '2rem', zIndex: 2 }}>
            <span>▶</span>
          </div>
        </div>
        <div className="card__body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className="card__meta">
            <span className="badge badge--primary">In Evidenza</span>
            {duration && <span>{duration}</span>}
          </div>
          <h2 className="card__title">
            <Link to={link}>{title}</Link>
          </h2>
        </div>
      </div>
    );
  }

  return (
    <article className="card video-card">
      <div
        className="card__image"
        style={{
          aspectRatio: '16/9',
          background: 'var(--color-surface-subtle)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        {isUrl ? (
          <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#e27314,#7a1f1c)' }} />
        )}
        <div className="video-card__play" style={{ position: 'relative', zIndex: 2 }}><span>▶</span></div>
        {duration && <div className="video-card__duration" style={{ zIndex: 2 }}>{duration}</div>}
      </div>
      <div className="card__body">
        <div className="card__meta">
          {category && <span>{category}</span>}
          {category && date && <span className="card__meta-dot"></span>}
          {date && <span>{date}</span>}
        </div>
        <h4 className="card__title">
          <Link to={link}>{title}</Link>
        </h4>
      </div>
    </article>
  );
};

export default VideoCard;
